import api from '@/api';

export type McpIntegrationMeta = {
  id: string;
  name: string;
  transport: 'http' | 'stdio';
  enabled: boolean;
  url?: string;
  permission: 'read' | 'read_write';
  hasHeaders?: boolean;
};

export async function listMcpIntegrations(): Promise<McpIntegrationMeta[]> {
  const res = await api.get<{ status?: string; integrations?: McpIntegrationMeta[] }>('/integrations/mcp');
  return res.data.integrations ?? [];
}

export async function createMcpIntegration(body: {
  name: string;
  transport?: 'http' | 'stdio';
  url?: string;
  headers?: Record<string, string>;
  permission?: 'read' | 'read_write';
}): Promise<string> {
  const res = await api.post<{ status?: string; id?: string }>('/integrations/mcp', body);
  if (!res.data.id) throw new Error('Create failed');
  return res.data.id;
}

export async function patchMcpIntegration(
  id: string,
  body: { enabled?: boolean; name?: string; headers?: Record<string, string> }
): Promise<void> {
  await api.patch(`/integrations/mcp/${id}`, body);
}

export async function deleteMcpIntegration(id: string): Promise<void> {
  await api.delete(`/integrations/mcp/${id}`);
}

export async function testMcpIntegration(id: string): Promise<{ tools: Array<{ name: string; description?: string }> }> {
  const res = await api.post<{ status?: string; tools?: Array<{ name: string; description?: string }> }>(
    `/integrations/mcp/${id}/test`,
    {}
  );
  return { tools: res.data.tools ?? [] };
}
